import { gql } from '@apollo/client';

export const IMPORT_ASSET_HIERARCHY = gql`
  mutation importAssetHierarchy($input: ImportAssetHierarchyInput) {
    importAssetHierarchy(input: $input) {
      commandId
    }
  }
`;
